import React, { useState, useEffect } from 'react';
import { get } from 'aws-amplify/api';
import { ProfileContainer, SubscriptionStatus, CustomLink } from './ProfileComponents';
import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { StyleSheetManager } from 'styled-components';
import { useNavigate } from 'react-router-dom';

function Profile() {

  const [subscriptionStatus, setSubscriptionStatus] = useState("");
  const [user, setUser] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("subscriptionStatus") === "true") {
      setSubscriptionStatus("Active");
      fetchUserEmail();
    } else {
      navigate('/checkout')
    }

  }, [navigate]); // Run once on component mount

  const fetchUserEmail = async () => {
    try {
      setUser(await fetchUserAttributes());
    } catch (error) {
      console.log('ERROR CODE AE01');
    }
  };

  const handleBillingButtonClick = async (buttonRef) => {
    try {
      buttonRef.style.cursor = 'wait';
      const restOperation = get({ apiName: 'userapi', path: '/billing' });
      const { body } = await restOperation.response;
      window.location.href = (await body.json()).portalURL;
    } catch (e) {
      console.log("ERROR CODE: PP01");
    } finally {
      buttonRef.style.cursor = 'pointer';
    }
  };

  const isActiveString = (subscriptionStatus === 'Active').toString();

  return (
    <ProfileContainer style={{ backgroundColor: 'var(--background-color)'}}>
      <MDBContainer className="py-5">
        <MDBTable style={{ marginBottom: '3rem' }}>
          <MDBTableHead>
            <tr>
              <th colSpan="2" style ={{backgroundColor: 'var(--background-color)', color: 'var(--textColor)'}}><h1>Account Details</h1></th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            <tr>
              <td style={{ textAlign: 'left', backgroundColor: 'var(--background-color)', color: 'var(--textColor)' }}><h5>Email: {user.email}</h5></td>
            </tr>
            <tr>
              <td style={{ textAlign: 'left', backgroundColor: 'var(--background-color)', color: 'var(--textColor)'  }}><h5>Name: {user.name}</h5></td>
            </tr>
            <tr>
              <td style={{ textAlign: 'left', backgroundColor: 'var(--background-color)', color: 'var(--textColor)'  }}><h5>Phone Number: {user.phone_number}</h5></td>
            </tr>
          </MDBTableBody>
        </MDBTable>
        <MDBTable>
          <StyleSheetManager shouldForwardProp={(prop) => prop !== 'isactive'}>
            <MDBTableHead>
              <tr>
                <th style={{ textAlign: 'left', backgroundColor: 'var(--background-color)', color: 'var(--textColor)'  }}><h1>Subscription</h1></th>
                <th style={{ textAlign: 'right', backgroundColor: 'var(--background-color)', color: 'var(--textColor)'  }}> <SubscriptionStatus isactive={isActiveString}> {subscriptionStatus} </SubscriptionStatus> </th>
              </tr>
            </MDBTableHead>
          </StyleSheetManager>
          <MDBTableBody>
            <tr>
              <td style={{ textAlign: 'left', backgroundColor: 'var(--background-color)', color: 'var(--textColor)'  }}><h5>Billing Details</h5></td>
              <td style={{ textAlign: 'right', backgroundColor: 'var(--background-color)', color: 'var(--textColor)'  }}><CustomLink href="#" className="text-primary" onClick={(e) => handleBillingButtonClick(e.target)}>Manage Subscription and Billing</CustomLink></td>
            </tr>
          </MDBTableBody>
        </MDBTable>        
      </MDBContainer>
    </ProfileContainer>
  );
}
  
export default Profile;
